import * as React from 'react';

import { ValueRanges } from 'rlv-common';
import {
  getTrackingBirthdate,
  mapFetchedNeedData,
  mapTrackingInsuredPerson,
} from '../../../../tracking/trackingFormating';

import { ViewName } from '../../../../helpers/ViewName';
import NeedsPageContainer from '../../../../pages/needs/NeedsPageContainer';
import { DecreasingNeedData } from '../../../../pages/needs/Needs.types';
import { getAngebot, updateDecreasingNeedBlockData } from '../../../../services/api';
import { PagePercentage } from '../../../../types/PagePercentage';
import { createNeedPageSchema } from '../../../../validation/NeedPage';
import { FetchedTrackingData, StateDefinition } from '../../../StateMachine';
import { NavigationAction, StateName } from '../../../StateMachineTypes';

export const decreasingInsuranceEndSumState: StateDefinition<DecreasingNeedData> = {
  name: StateName.DECREASING_INSURANCE_END_SUM,
  percentage: PagePercentage.DECREASING_INSURANCE_END_SUM,
  trackingViewName: ViewName.BEDARFSANALYSE,
  createValidationSchema: (valueRanges: ValueRanges) => createNeedPageSchema(valueRanges),
  validInboundStates: [StateName.DECREASING_YEARS_TERM, StateName.LIVING_CONDITIONS_EMPLOYMENT],
  transitions: [
    {
      test: action => {
        const backAction =
          action === NavigationAction.BACK || action === NavigationAction.BROWSER_BACK;
        return backAction;
      },
      newState: StateName.DECREASING_YEARS_TERM,
    },
    {
      test: action => action === NavigationAction.NEXT,
      newState: StateName.LIVING_CONDITIONS_EMPLOYMENT,
    },
  ],
  onEnter: async (_, inputData) => {
    const response = await getAngebot(inputData.businessId);

    const fetchedTrackingData: FetchedTrackingData = {
      userAttributes: {
        ...mapTrackingInsuredPerson(),
        ...getTrackingBirthdate(response.livingConditionsModel),
      },
      tariffOptions: {
        ...mapFetchedNeedData(response.needSelectionModel),
      },
    };

    if (response.feeCalculationModel) {
      fetchedTrackingData.tariffOptions!.VersSumEJ = response.feeCalculationModel.sumInsured;
      fetchedTrackingData.tariffOptions!.VersLZ = response.feeCalculationModel.periodInYears;
    }

    return {
      userInput: response.decreasingNeedModel,
      valueRanges: response.valueRanges,
      fetchedTrackingData,
    };
  },
  onExit: async (_, inputData) => {
    await updateDecreasingNeedBlockData(inputData.businessId, inputData.userInput);
    return {};
  },

  render: (inputData, handleAction, updateApp, _unused, updateDTMTracking) => {
    const userInput: DecreasingNeedData = inputData.userInput;
    return (
      <NeedsPageContainer
        businessId={inputData.businessId}
        inputData={inputData}
        updateApp={updateApp}
        storeState={{
          // In this case, we need the sum insured to be displayed as a max ammount
          sumInsured: userInput.sumInsured,
          insuranceEndSum: userInput.insuranceEndSum,
          // We need to send this values to update the tracker
          periodInYears: userInput.periodInYears,
          update: values => updateApp(values),
        }}
        valueRanges={inputData.valueRanges}
        handleAction={handleAction}
        updateDTMTracking={updateDTMTracking}
      />
    );
  },
};
